module.exports = __webpack_public_path__ + "9ed09eb43155dece8d19e4b73283c60d.jpg";